import React from 'react'
import PropTypes from 'prop-types'
import { Exceptions } from './Exceptions'
import { NewException } from './NewException'
import { SelectAssignments } from './SelectAssignments'
import { Review } from './Review'
import { StateProvider } from '@State'
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'

export const App = props => {
  const initialState = {
    exceptionType: '',
    extraTime: 0,
    shiftDays: 0,
    shiftHours: 0,
    shiftMinutes: 0,
    aggregatedRules: props.aggregatedRules,
    override: false,
    isExceptionSet: false,
    selectedAssignments: {},
    lateRulesList: props.lateRulesList,
    timeLimitRulesList: props.timeLimitRulesList,
    selectedForDelete: null,
    timezone: props.timezone,
  }

  const reducer = (state, action) => {
    switch (action.type) {
      case 'updateExceptionType':
        return {
          ...state,
          exceptionType: action.exceptionType,
          extraTime: action.extraTime,
          shiftDays: action.shiftDays,
          shiftHours: action.shiftHours,
          shiftMinutes: action.shiftMinutes,
          override: action.override,
          isExceptionSet: true,
        }
      case 'resetException':
        return {
          ...state,
          exceptionType: '',
          extraTime: 0,
          shiftDays: 0,
          shiftHours: 0,
          shiftMinutes: 0,
          override: false,
          isExceptionSet: false,
          selectedAssignments: {},
        }
      case 'updateSelectedAssignments':
        return {
          ...state,
          selectedAssignments: action.selectedAssignments,
        }
      case 'updateAggregatedRules':
        return {
          ...state,
          aggregatedRules: action.aggregatedRules,
        }
      case 'updateRuleIdToDelete':
        return {
          ...state,
          selectedForDelete: action.selectedForDelete,
        }
    }
  }

  return (
    <StateProvider initialState={initialState} reducer={reducer}>
      <a
        href={`/course/progress/${props.coursenum}/${props.studentId}/root`}
        type="button"
        className="btn btn-myed btn-default btn-default-myed btn-sm-myed ml-4"
      >
        <div className="fa-regular fa-chevron-left mr-2" aria-hidden="true" />
        Student Progress
      </a>
      <h1 className="me-course-title">{props.courseTitle}</h1>
      <h1 className="me-page-title">Bulk Student Exceptions</h1>
      <div className="container d-flex justify-content-center">
        <div className="card-myed w-75">
          <p className="mb-0" style={{ fontSize: '2.5em' }}>
            {props.studentName}
          </p>
          <Router>
            <Switch>
              <Route
                exact
                path="/instructor/ada_exceptions/:coursenum/:studentid/"
                component={Exceptions}
              />
              <Route
                exact
                path="/instructor/ada_exceptions/:coursenum/:studentid/new_exception"
                component={NewException}
              />
              <Route
                exact
                path="/instructor/ada_exceptions/:coursenum/:studentid/select_assignments"
                component={SelectAssignments}
              />
              <Route
                exact
                path="/instructor/ada_exceptions/:coursenum/:studentid/review"
                component={Review}
              />
            </Switch>
          </Router>
        </div>
      </div>
    </StateProvider>
  )
}

App.propTypes = {
  coursenum: PropTypes.string.isRequired,
  timeLimitRulesList: PropTypes.array.isRequired,
  lateRulesList: PropTypes.array.isRequired,
  studentId: PropTypes.string.isRequired,
  aggregatedRules: PropTypes.array.isRequired,
  studentName: PropTypes.string.isRequired,
  courseTitle: PropTypes.string.isRequired,
  timezone: PropTypes.string.isRequired,
}
